import { Select } from "antd";
import React from "react";

const { Option } = Select;

const SolutionAccessDropDown = (props) => {
  const {
    app_name,
    onChange,
    value,
    options = [],
    isLoading = false,
    ...rest
  } = props;
  return (
    <Select
      placeholder={`${app_name} Solution Access`}
      showSearch
      onChange={(values) => {
        onChange(values);
      }}
      value={value}
      optionFilterProp="children"
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      {...rest}
    >
      {options.map((option) => {
        return (
          <Option key={option?._id} value={option?._id}>
            {option?.role_name}
          </Option>
        );
      })}
      <Option value={null}>No</Option>
    </Select>
  );
};

export default SolutionAccessDropDown;
